import React from "react";
import { Popover as NBPopover } from "native-base";
import { composeEventHandlers } from "native-base/lib/module/utils";

export const Popover = (() => {
    class Popover extends React.Component {
        renderTrigger = (triggerProps) => {
            const { onBlur, onFocus, onMouseEnter, onMouseLeave, onPress, } = this.props;
            return this.props.trigger({
                ...triggerProps,
                onBlur, onFocus, onMouseEnter, onMouseLeave, 
                onPress: composeEventHandlers(onPress, triggerProps.onPress),
            });
        }
        
        render() {
            const { onBlur, onFocus, onMouseEnter, onMouseLeave, onPress, forwardedRef, ...rest } = this.props;
            return <NBPopover { ...rest} ref={forwardedRef} trigger={ this.renderTrigger } />
        }
    }

    return React.forwardRef((props, ref) => <Popover { ...props } forwardedRef={ref} />)
})();


Popover.Content = NBPopover.Content;
Popover.CloseButton = NBPopover.CloseButton;
Popover.Header = NBPopover.Header;
Popover.Footer = NBPopover.Footer;
Popover.Body = NBPopover.Body;
Popover.Arrow = NBPopover.Arrow;

